var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuranKid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.811,
    height: 242.24,
    viewBox: "0 0 222.811 242.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-131.025 -210.481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.006,357.36a3.233,3.233,0,0,0-2.863-1.733H188.386a3.234,3.234,0,0,0-2.831,1.672l-54.123,98.207a3.233,3.233,0,0,0,2.831,4.794H350.6a3.233,3.233,0,0,0,2.864-4.733Z",
    transform: "translate(0 -7.579)",
    fill: "#3889c8",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.25 210.481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 137.567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.5,355.627H186.875L138.648,455.62H349.723Z",
    transform: "translate(-138.648 -355.627)",
    fill: "#c5def3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,445.3l37.694-78.155H295.6L333.293,445.3Z",
    transform: "translate(-139.606 -356.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.837,
    cy: 16.833,
    rx: 71.837,
    ry: 16.833,
    transform: "translate(33.048 45.073)",
    fill: "#c5def3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.871)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.558 63.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.02,370.926a33.672,33.672,0,0,0,16.2-2.67h77.056a118.926,118.926,0,0,0,19.522,7.052s-25.9,29.572-67.5,30.937S195.02,370.926,195.02,370.926Z",
    transform: "translate(-195.02 -282.269)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.034,285.058c-25.261,14.84-27.013,57.13-27.013,57.13l23.562,5.3s14.643-32.252,13.108-42.147S222.034,285.058,222.034,285.058Z",
    transform: "translate(-195.021 -277.925)",
    fill: "#01918b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9,292.653c16.037,21.952,16.743,48.637,13.308,57.377-3.584,9.114-15.451,8.153-15.451,8.153s-12.418-27.877-13.327-41.272S291.9,292.653,291.9,292.653Z",
    transform: "translate(-199.27 -278.322)",
    fill: "#01918b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.432,277.532s-24.173,2.481-29.178,10.2c-4.554,7.026-4.044,51.437-3.749,66a12.164,12.164,0,0,1-2.926,8.162l-7.429,8.673s14.68,9.554,43.282,9.554,42.478-12.738,42.478-12.738l-5.173-11.724a28.444,28.444,0,0,1-2.043-16.126c2.371-14.353,6.681-42.78,4.487-47.674C285.223,285.267,270.786,277.987,248.432,277.532Z",
    transform: "translate(-205.15 -277.532)",
    fill: "#4cba8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,365.363l-3.066-6.948a28.444,28.444,0,0,1-2.043-16.126c.56-3.394,1.229-7.578,1.9-12.049l-52.1,9.517-18.162-4.521c-.039,8.692.08,16.537.174,21.252a12.164,12.164,0,0,1-2.926,8.162l-7.429,8.673C247.747,363.438,277.984,364.487,288.8,365.363Z",
    transform: "translate(-205.15 -280.284)",
    fill: "#01918b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.027,337.569l-11.974,2.188-18.162-4.521c-.039,8.692.08,16.537.174,21.252.006.281-.008.558-.021.837l.04.069c22.155-8.639,59.5-1.1,70.513,2.751a4.473,4.473,0,0,0,.528.147l-.828-1.878a28.444,28.444,0,0,1-2.043-16.126c.56-3.394,1.229-7.578,1.9-12.049l-27.2,4.968-10.363,2.856Z",
    transform: "translate(-205.71 -280.284)",
    fill: "#0b7777"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.682,306.758c3.768-2.509,16.235-11.39,18.4-20.341l.3-1.229-.163-1.253c0-.03-.085-.661-.213-1.7-6.733-2.618-15.782-4.483-26.739-4.706,0,0-4.371.451-9.778,1.56-.046,2.049-.149,3.276-.151,3.3l-.082.914.163.9c.251,1.392,2.649,13.82,9.38,21.4l3.941,4.44Z",
    transform: "translate(-240.254 -277.532)",
    fill: "#f9bc14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.087,285.1l-.109-.84c-.046-.362-.18-1.41-.36-2.884-.693-.23-1.409-.451-2.143-.666.238,1.972.419,3.395.476,3.839l.057.438-.1.43c-.838,3.465-3.838,7.4-9.171,12.02a82.062,82.062,0,0,1-7.376,5.672l-1.731,1.152-1.379-1.554c-6.03-6.793-8.241-18.742-8.332-19.246l-.057-.316.028-.323c.01-.118.15-1.8.185-4.5-.647.105-1.335.225-2.057.355-.042,2.444-.166,3.945-.168,3.969l-.052.593.105.587c.095.529,2.408,13.024,8.815,20.242l2.562,2.887,3.212-2.138a82.5,82.5,0,0,0,7.583-5.829c5.667-4.912,8.879-9.193,9.821-13.085Z",
    transform: "translate(-240.387 -277.573)",
    fill: "#f1951f"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.069 44.969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.512,269.684a89.511,89.511,0,0,1,0,12.283s2.114,11.716,7.767,18.085c0,0,13.843-9.212,15.549-16.264,0,0-1.933-14.9-2.275-22.635S247.339,260.919,247.512,269.684Z",
    transform: "translate(-247.511 -257.927)",
    fill: "#ee6e76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.053,267.48l-2.857-9.546c-6.2-.119-16.808,5.491-16.685,11.751a89.511,89.511,0,0,1,0,12.283s.009.051.027.144C253.546,281.782,261.352,278.807,267.053,267.48Z",
    transform: "translate(-247.511 -257.927)",
    fill: "#0c1a3b",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.039,231.72s4.846-26.956,30.892-20.132,14.331,32.978,14.331,32.978S262.95,225.01,236.039,231.72Z",
    transform: "translate(-236.039 -210.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.788 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.911,211.588a27.317,27.317,0,0,0-13.1-.548q1.176.225,2.412.548c17.554,4.6,17.956,17.978,16.352,26.213a46.351,46.351,0,0,1,8.671,6.765S293.957,218.412,267.911,211.588Z",
    transform: "translate(-254.807 -210.483)",
    fill: "#c5def3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.4,223.332a33.26,33.26,0,0,0-3.356,9.017c26.911-6.71,45.224,12.846,45.224,12.846a35.316,35.316,0,0,0,2.477-9.843C278.694,231.164,262.133,219.391,239.4,223.332Z",
    transform: "translate(-236.039 -222.537)",
    fill: "#c5def3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,245.461l.056-.133.007-.016.092-.224,0,0c.035-.087.075-.19.118-.3l.017-.045c.09-.234.2-.517.31-.844l.014-.041c.058-.164.118-.339.179-.524l.016-.05c.125-.378.257-.8.39-1.256l.02-.068q.1-.344.2-.715l.008-.031q.1-.374.2-.772l.006-.025c.063-.263.126-.535.188-.811l.02-.095c.121-.558.234-1.144.335-1.752l.017-.1q.073-.451.135-.916l.012-.1c.042-.317.08-.637.113-.963h0a56.823,56.823,0,0,0-10.877-6.993,28.451,28.451,0,0,1-.271,10.07c.312.192.611.384.907.576l.161.1q.435.284.846.564l.119.082a47.668,47.668,0,0,1,6.035,4.84l.04.038c.079.076.145.141.208.2l.064.063.133.134.056.056.064.066.04.041.013-.03Z",
    transform: "translate(-238.053 -222.858)",
    fill: "#3889c8",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.242)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.196 3.488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.78,250.007s-2.474-1.45-2.73,2.474,3.884,7.375,3.884,7.375l3.367-6.436Z",
    transform: "translate(-236.039 -229.261)",
    fill: "#ee6e76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.756,234.461a35.53,35.53,0,0,0,1.82,19.677s-5.232,7.734,2.844,14.673,23.2,5.8,27.866-10.919c.719-2.578,1.281-4.991,1.718-7.229a18.826,18.826,0,0,0-18.843-22.521C247.246,228.325,241.382,229.9,237.756,234.461Z",
    transform: "translate(-236.095 -228.132)",
    fill: "#f39091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.422,268.811c-6.476-5.564-4.395-11.64-3.315-13.828a2.3,2.3,0,0,0,.094-1.8,35.965,35.965,0,0,1-1.443-18.72c3.528-4.44,9.176-6.045,14.927-6.3-.5-.025-1.009-.038-1.524-.022-5.915.184-11.779,1.756-15.405,6.32a35.53,35.53,0,0,0,1.82,19.677s-5.232,7.734,2.844,14.673a16.8,16.8,0,0,0,11.867,3.967A16.794,16.794,0,0,1,244.422,268.811Z",
    transform: "translate(-236.095 -228.133)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.317 10.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.15,264.962a10.39,10.39,0,0,1-5.423-1.763,1,1,0,0,1,1.157-1.631,8.325,8.325,0,0,0,4.489,1.389,13.717,13.717,0,0,0,5.353-1.878,1,1,0,0,1,1.049,1.7,15.53,15.53,0,0,1-6.32,2.173C253.353,264.96,253.251,264.962,253.15,264.962Z",
    transform: "translate(-240.989 -240.799)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.135,248.484c-.141,1.717-1.124,3.039-2.2,2.951s-1.825-1.552-1.685-3.27,1.124-3.04,2.2-2.951S248.276,246.765,248.135,248.484Z",
    transform: "translate(-240.784 -239.998)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.066,248.484c-.14,1.717-1.123,3.039-2.2,2.951s-1.825-1.552-1.685-3.27,1.124-3.04,2.2-2.951S262.208,246.765,262.066,248.484Z",
    transform: "translate(-241.511 -239.998)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.423,257.468a15.65,15.65,0,0,1-5.638-1.035,2.335,2.335,0,0,1-1.323-1.66,2.413,2.413,0,0,1,.561-2.09c1.162-1.3,3.674-5.143,1.906-12.649l2.736-.645a20.51,20.51,0,0,1,.13,10.041,12.821,12.821,0,0,1-2.286,4.663,14.119,14.119,0,0,0,3.929.564l.021,2.811Z",
    transform: "translate(-241.127 -239.711)",
    fill: "#ee6e76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.221,255.3c.048.952-1.123,1.784-2.617,1.859s-2.743-.634-2.791-1.585,1.124-1.783,2.617-1.859S265.173,254.347,265.221,255.3Z",
    transform: "translate(-241.597 -240.442)",
    fill: "#ee6e76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,255.3c.048.952-1.124,1.784-2.617,1.859s-2.743-.634-2.791-1.585,1.123-1.783,2.617-1.859S245.955,254.347,246,255.3Z",
    transform: "translate(-240.593 -240.442)",
    fill: "#ee6e76"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M237.191,245.967c.846-3.167,3.065-2.911,4.515-5.47s-.427-5.119-.427-5.119a10.956,10.956,0,0,0,7.677,0s5.2,3.668,9.724,0c0,0,1.038,3.469,5.8,2.474,0,0-1.977,3.157,1.741,5.034,0,0-2.253,1.926.306,4.2s1.877,4.354,1.877,4.354,1.621,9.4,6.227,8.355,3.583-4.886,3.583-4.886a9.917,9.917,0,0,0,4.181-8.53c0-6.057-5.2-10.578-9.9-8.872,0,0,.853-7.08-7.165-7.677,0,0-1.194-4.862-9.384-3.156,0,0-3.357-5.118-9.27.171,0,0-4.719-2.73-7.279,3.071,0,0-5.459-1.621-7.251,2.388a4.537,4.537,0,0,0,1.45,5.971S229.263,241.628,237.191,245.967Z",
    transform: "translate(-231.612 -224.452)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.9,238.562a4.791,4.791,0,0,1,2.232-8.6c-1.724-.219-4.74-.154-5.985,2.634a4.537,4.537,0,0,0,1.45,5.971s-4.338,3.349,3.589,7.688a5.711,5.711,0,0,1,.44-1.153C232.321,241.331,235.9,238.562,235.9,238.562Z",
    transform: "translate(-231.612 -229.879)",
    fill: "#3889c8",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.333,249.393c-3.412-3.639-6.938,3.3-6.938,3.3l-.682,7.961C276.765,263.156,280.745,253.032,277.333,249.393Z",
    transform: "translate(-233.601 -225.7)",
    fill: "#f39091"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.557 84.124)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.222 11.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.623,311.06C269.7,318.481,254.7,317.8,248.5,328.073c-6.2-10.269-21.2-9.592-32.121-17.013l-2.19,2.7,3.4,22.193L248.5,354.635l30.909-18.682,3.4-22.193Z",
    transform: "translate(-213.242 -311.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.52,330.741c-6.2-10.269-21.2-9.591-32.121-17.012l-1.864,2.3,3.077,20.066,30.909,18.682,30.909-18.682,3.077-20.066-1.864-2.3C269.722,321.15,254.718,320.472,248.52,330.741Z",
    transform: "translate(-213.26 -311.199)",
    fill: "#c5def3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.535,332.991c-6.2-10.269-21.2-9.591-32.121-17.012l-1.589,1.959,2.8,18.272,30.909,18.682,30.909-18.682,2.8-18.272-1.589-1.959C269.737,323.4,254.733,322.722,248.535,332.991Z",
    transform: "translate(-213.275 -311.317)",
    fill: "#3889c8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.863,312.65l-.673.61,3.639,22.928,30.71,19.383V334.429a1.9,1.9,0,0,0-.907-1.623Z",
    transform: "translate(-213.19 -311.143)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.029,312.65l.673.61-3.639,22.928-30.71,19.383V334.429a1.9,1.9,0,0,1,.907-1.623Z",
    transform: "translate(-215.183 -311.143)",
    fill: "#0c1a3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.19,313.294l3.64,23.952,30.71,19.383V334.422Z",
    transform: "translate(-213.19 -313.294)",
    fill: "#e83e4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,313.294l-3.64,23.952-30.71,19.383V334.422Z",
    transform: "translate(-215.183 -313.294)",
    fill: "#e83e4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.238,322.09l-21.5,13.224a4.034,4.034,0,0,1-1.919,3.337l-.188,7.723a1.476,1.476,0,0,1,2.264,1.284l22.669-14.308a4.032,4.032,0,0,1,1.842-2.861l.8-5.812A2.62,2.62,0,0,1,280.238,322.09Z",
    transform: "translate(-215.459 -313.753)",
    fill: "#0c1a3b",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.026,322.09l21.5,13.224a4.036,4.036,0,0,0,1.919,3.337l.189,7.723a1.477,1.477,0,0,0-2.265,1.284L217.7,333.351a4.032,4.032,0,0,0-1.842-2.861l-.8-5.812A2.62,2.62,0,0,0,219.026,322.09Z",
    transform: "translate(-213.288 -313.753)",
    fill: "#0c1a3b",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.147,334.64a9.716,9.716,0,0,1-4.452-1.353l.833,22.676s.917,3.245,3.619,3.245,3.619-3.245,3.619-3.245l.833-22.676A9.716,9.716,0,0,1,250.147,334.64Z",
    transform: "translate(-214.888 -314.338)",
    fill: "#0c1a3b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.08,334.881a43.4,43.4,0,0,0,2.537-8.6,17.838,17.838,0,0,0-.267-6.63s5.23-6.9,4.928-8.705S221.9,309.2,221.9,309.2l-3.114,3.109s2.133-6.63,1.809-8.082-2.56-2.508-2.56-2.508-2.036-2.931-3.414-2.416-8.314,9.267-9.03,13.225.829,14.852.829,14.852l-2.389,3.44S209.157,336.826,216.08,334.881Z",
    transform: "translate(-204.027 -299.24)",
    fill: "#f39091"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.994 11.704)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.516,335.893c1.3-2.514,3.491-6.954,4.111-9.5a17.848,17.848,0,0,0,.386-6.624s5.883-6.348,5.762-8.178c.3,1.808-4.928,8.705-4.928,8.705a17.838,17.838,0,0,1,.267,6.63,43.4,43.4,0,0,1-2.537,8.6A10.13,10.13,0,0,1,213.516,335.893Z",
    transform: "translate(-213.516 -311.589)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.587,313.163a8.348,8.348,0,0,1,.554-1.721,27.633,27.633,0,0,0,5.729,7.973,6.265,6.265,0,0,1,1.834,4.971,25.118,25.118,0,0,1-3.6,11.011,14.625,14.625,0,0,1-6.073-3.942l2.389-3.44S204.871,317.122,205.587,313.163Z",
    transform: "translate(-204.027 -299.877)",
    fill: "#ee6e76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.3,323.37s-10.1,9.331-10.282,20.818,13.512,20.358,19.974,12.847c7.826-9.093,2.223-25.476,2.223-25.476S209.63,336.02,205.3,323.37Z",
    transform: "translate(-195.019 -323.37)",
    fill: "#4cba8f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.766,343.365c1.076-7.579,6.4-13.656,9.831-16.87a24.914,24.914,0,0,1-1.295-3.125s-10.1,9.331-10.282,20.818a16.25,16.25,0,0,0,7.451,13.517A16.249,16.249,0,0,1,196.766,343.365Z",
    transform: "translate(-195.019 -323.37)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.121 8.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.776,332.011a6.7,6.7,0,0,1-5.675.233c1.033,6.717,1.618,17.546-3.467,24.671a8.14,8.14,0,0,1-2.935,2.6c3.542,1.348,7.274.966,9.854-2.033C223.378,348.393,217.776,332.011,217.776,332.011Z",
    transform: "translate(-205.698 -332.011)",
    fill: "#01918b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.643,334.881a43.394,43.394,0,0,1-2.537-8.6,17.839,17.839,0,0,1,.267-6.63s-5.23-6.9-4.928-8.705,1.383-1.747,1.383-1.747l3.114,3.109s-2.133-6.63-1.809-8.082,2.56-2.508,2.56-2.508,2.036-2.931,3.414-2.416,8.314,9.267,9.03,13.225-.829,14.852-.829,14.852l2.389,3.44S290.565,336.826,283.643,334.881Z",
    transform: "translate(-276.432 -299.24)",
    fill: "#f39091"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.704)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.7,335.893c-1.3-2.514-3.491-6.954-4.111-9.5a17.847,17.847,0,0,1-.386-6.624s-5.883-6.348-5.762-8.178c-.3,1.808,4.928,8.705,4.928,8.705a17.839,17.839,0,0,0-.267,6.63,43.394,43.394,0,0,0,2.537,8.6A10.129,10.129,0,0,0,286.7,335.893Z",
    transform: "translate(-276.432 -311.589)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.663,313.163a8.348,8.348,0,0,0-.554-1.721,27.631,27.631,0,0,1-5.729,7.973,6.265,6.265,0,0,0-1.834,4.971,25.118,25.118,0,0,0,3.6,11.011,14.625,14.625,0,0,0,6.073-3.942l-2.389-3.44S295.378,317.122,294.663,313.163Z",
    transform: "translate(-276.959 -299.877)",
    fill: "#ee6e76"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.66 22.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.152,323.37s10.1,9.331,10.282,20.818-13.512,20.358-19.974,12.847c-7.826-9.093-2.224-25.476-2.224-25.476S289.824,336.02,294.152,323.37Z",
    transform: "translate(-280.294 -323.37)",
    fill: "#4cba8f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.236,332.011a6.7,6.7,0,0,0,5.675.233c-1.033,6.717-1.618,17.546,3.467,24.671a8.14,8.14,0,0,0,2.935,2.6c-3.542,1.348-7.274.966-9.854-2.033C276.634,348.393,282.236,332.011,282.236,332.011Z",
    transform: "translate(-280.294 -332.011)",
    fill: "#01918b"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 152.207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.234 32.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.827,406.606c14.559,2.048,32.236-.91,37.16-1.251s5.609,6.65,3.267,11.147-2.438,11.943-7.1,13.876-14.559.341-23.544-1.82a58.906,58.906,0,0,1-14.629-5.46S249.775,414.8,256.827,406.606Z",
    transform: "translate(-251.654 -405.343)",
    fill: "#ee6e76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.987,405.355c-4.924.341-22.6,3.3-37.16,1.251-7.052,8.19-4.847,16.492-4.847,16.492a58.885,58.885,0,0,0,14.629,5.459c.553.134,1.11.264,1.668.392a121.213,121.213,0,0,1,26.587-5.452,44.59,44.59,0,0,1,2.389-7C299.6,412.005,298.911,405.014,293.987,405.355Z",
    transform: "translate(-251.654 -405.343)",
    fill: "#0c1a3b",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.681,380.138c-10.637,19.2,16.888,37.77,40.871,41.987a172.015,172.015,0,0,0,35.729,2.011l3.015-26.387s-33.837-13.042-47.031-20.852S182.311,368.167,175.681,380.138Z",
    transform: "translate(-173.33 -371.074)",
    fill: "#55164a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.195,415.772c-24.343.652-55.018-12.052-48.424-32.991,2.094-6.651,6.417-10.334,12.068-11.688-5.807.2-10.779,2.947-14.157,9.046-10.637,19.2,16.888,37.771,40.871,41.988a172.012,172.012,0,0,0,35.729,2.011l1.335-11.692A164.8,164.8,0,0,1,226.195,415.772Z",
    transform: "translate(-173.33 -371.075)",
    fill: "#93415d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.89 3.026)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.588,408.628c-14.558,2.048-32.236-.91-37.16-1.251s-5.608,6.65-3.267,11.147,2.439,11.942,7.1,13.876,14.558.341,23.544-1.82a58.973,58.973,0,0,0,14.629-5.46S253.641,416.818,246.588,408.628Z",
    transform: "translate(-204.866 -407.365)",
    fill: "#f39091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,408.629c-14.558,2.048-32.236-.91-37.16-1.251,17.125,7.651,26.7,16.4,31.569,22.048a54.861,54.861,0,0,0,10.439-4.3S253.892,416.819,246.84,408.629Z",
    transform: "translate(-205.118 -407.366)",
    fill: "#ee6e76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.154,402.237c-.343,15.924,10.364,26.843,10.364,26.843s55.262-12.512,61.631-31.848-5.361-26.161-23.722-21.61S244.154,402.237,244.154,402.237Z",
    transform: "translate(-244.145 -374.266)",
    fill: "#93415d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5,376.79c6.353-2.063,11.976-2.645,16.382-1.676-4.326-1.28-9.975-1.1-16.459.508-18.361,4.549-48.273,26.615-48.273,26.615a35.075,35.075,0,0,0,.463,6.446C252.968,401.677,277.717,381.591,292.5,376.79Z",
    transform: "translate(-244.145 -374.266)",
    fill: "#fff",
    opacity: 0.2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuranKid);
export default __webpack_public_path__ + "static/media/quran-kid.67f29ce0aa4635cac4b2ca5675aca2b4.svg";
export { ForwardRef as ReactComponent };